import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store/index";
import VueCookies from "vue-cookies";
import i18n from "./i18n";
import setupInterceptors from "./services/planning/SetupInterceptors";

import VueRecaptcha from "vue-recaptcha";
Vue.use(VueRecaptcha);

Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.$cookies.config("1h");

setupInterceptors();

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

// global variable
Vue.prototype.$enumUserType = [
  { text: i18n.t("enumUser.trainer"), value: "FORMATEUR" },
  { text: i18n.t("enumUser.notAssigned"), value: "INTERVNOTASSIGN" },
  { text: i18n.t("enumUser.independent"), value: "INDEPENDANT" },
  { text: i18n.t("enumUser.admincom"), value: "ADMINISTRATIF_COMMERCIAL" },
  { text: i18n.t("enumUser.apprenti"), value: "APPRENTI" },
  { text: i18n.t("enumUser.extApprenti"), value: "EXTAPPRENTICE" },
  { text: i18n.t("enumUser.rh"), value: "RH" },
  { text: i18n.t("enumUser.compt"), value: "COMPTABLE" },
  { text: i18n.t("enumUser.it"), value: "IT" },
  { text: i18n.t("enumUser.notFound"), value: "NOTFOUND" },
  // { text: i18n.t("enumUser.sales"), value: "COMMERCIAL" },
  // { text: i18n.t("enumUser.admin"), value: "ADMINISTRATIF" },
];
Vue.prototype.$enumUserCompany = [
  { text: "Dawan", value: "DAWAN" },
  { text: "Jehann", value: "JEHANN" },
  { text: i18n.t("enumCompany.other"), value: "OTHER" },
];
Vue.prototype.$enumInterventionStatus = [
  { text: i18n.t("enumIntStatus.internal"), value: "INTERN" },
  { text: i18n.t("enumIntStatus.custom"), value: "INTRA" },
  { text: i18n.t("enumIntStatus.eop"), value: "POE" },
  { text: i18n.t("enumIntStatus.professionalTitle"), value: "TP" },
  { text: i18n.t("enumIntStatus.interventionSuivie"), value: "IS" },
  { text: i18n.t("enumIntStatus.subcontracting"), value: "SOUS_TRAITANT" },
];
Vue.prototype.$enumLeavePeriodType = [
  { text: i18n.t("enumLeavePeriodType.cp"), value: "CP" },
  { text: i18n.t("enumLeavePeriodType.cef"), value: "CEF" },
  { text: i18n.t("enumLeavePeriodType.css"), value: "CSS" },
  { text: i18n.t("enumLeavePeriodType.cm"), value: "CM" },
  { text: i18n.t("enumLeavePeriodType.cpat"), value: "CPAT" },
  { text: i18n.t("enumLeavePeriodType.cmat"), value: "CMAT" },
  { text: i18n.t("enumLeavePeriodType.rc"), value: "RC" },
  { text: i18n.t("enumLeavePeriodType.rttc"), value: "RTTC" },
  { text: i18n.t("enumLeavePeriodType.rtti"), value: "RTTI" },
  { text: i18n.t("enumLeavePeriodType.cr"), value: "CR" },
  { text: i18n.t("enumLeavePeriodType.cra"), value: "CRA" },
  { text: i18n.t("enumLeavePeriodType.ul"), value: "UL" },
];
Vue.prototype.$enumEquipmentType = [
  { text: i18n.t("crudCategories.monitor"), value: "Ecran" },
  { text: i18n.t("crudCategories.mouse"), value: "Souris" },
  { text: i18n.t("crudCategories.keyboard"), value: "Clavier" },
  { text: i18n.t("crudCategories.headset"), value: "Casque" },
  { text: i18n.t("crudCategories.enumDesk"), value: "Poste" },
];
Vue.prototype.$enumDeskType = [
  { text: i18n.t("crudCategories.enumDesk"), value: "DESK" },
  { text: i18n.t("crudCategories.enumEquipment"), value: "EQUIPMENT" },
];
Vue.prototype.$typeErreur = 1;
